// extracted by mini-css-extract-plugin
var _1 = "IconNG-moduleIcon__AbXiV";
var _2 = "IconNG-moduleiconContainer__SxWZ0";
export { _1 as "Icon", _2 as "iconContainer" }
